/*
 * @Description:
 * @version:
 * @Author: linziying
 * @Date: 2019-08-19 16:33:37
 * @LastEditors: jia-wink 1847949884@qq.com
 * @LastEditTime: 2025-05-19 19:09:18
 */
/**
 * Created by mabiao on 2017/6/14.
 */
// 加载运行报警上报
import './bj_report';
import Vue from 'vue';
import {apiPath} from './config.js';
import myAjax from './request.js';
import store from '../../vuex/index.js';
import CommonQifuPop from '../components/commonQifuPop.vue';

var md5 = require('blueimp-md5');

/**
 * 补零
 */
let addZero = function (time) {
	return time <= 9 ? '0' + time : time;
};

const ydkPlatform = [32, 33, 69, '32', '33', '69'];

// 跳转APP配置
let appConfig = {
	closeWindow: false,
	needRefresh: false,
	needCallback: false
};

let commonQifuPopInstance = null;

function getCommonQifuPopInstance() {
	if (commonQifuPopInstance) {
		return commonQifuPopInstance;
	}

	const PopConstructor = Vue.extend(CommonQifuPop);
	commonQifuPopInstance = new PopConstructor().$mount();
	document.body.appendChild(commonQifuPopInstance.$el);

	return commonQifuPopInstance;
}

let commonFn = {
	/**
	 * 获得当前页面链接中的查询参数
	 * @param {null} 无需输入参数
	 * @return {object} 查询参数组成的key-vaule组合对象
	 * */
	getParams: function () {
		var search = location.href.split('?')[1];
		if (!search) {
			return {};
		}
		var params = search.split('&');
		return params.reduce(function (res, items) {
			var parts = items.split('=');
			res[parts[0]] = parts[1] + '';
			return res;
		}, {});
	},
	/**
	 * 设置分享卡片样式
	 * @param { Object | wxShareConfigObj } 微信配置信息为页面的分享配置信息
	 * @params
	 * {
	 *  wxConfig  微信配置信息
	 *  title     分享的标题
	 *  desc      分享的描述
	 *  link      分享的链接
	 *  imgUrl   分享的图片链接
	 *  type     分享的类型
	 *  dataUrl  分享类型的url
	 *  success  分享成功回调
	 *  cancel   分享取消回调
	 * }
	 * @return undefined
	 * */
	wxShare: function (wxShareConfigObj) {
		let that = this;
		// wx.config(wxShareConfigObj.wxConfig);
		wx.ready(function () {
			// 分享给朋友圈
			wx.onMenuShareTimeline({
				title: wxShareConfigObj.title || '易起问-东方智慧语音咨询平台', // 分享标题
				link: wxShareConfigObj.link || `${location.origin}?channel=1513246716`, // 分享链接
				imgUrl:
					wxShareConfigObj.imgUrl ||
					'https://zxcs.tengzhihh.com/forecastyiqiwenbundle/images/logo.png', // 分享图标
				success:
					wxShareConfigObj.success ||
					function () {
						that.shareData(wxShareConfigObj.title);
						// 分享成功后发送请求统计分享数量
						Vue.http
							.post(apiPath.shareStatic, {
								url:
									wxShareConfigObj.link ||
									`${location.origin}?channel=1513246716`,
								page_url: location.href
							})
							.then((res) => {})
							.catch((e) => {});
					},
				cancel: wxShareConfigObj.cancel || function () {}
			});
			// 分享到朋友
			wx.onMenuShareAppMessage({
				title: wxShareConfigObj.title || '易起问-东方智慧语音咨询平台',
				desc: wxShareConfigObj.desc || '这是一个神奇的游戏，快来测一下你2019年的桃花财运。', // 分享描述
				link: wxShareConfigObj.link || `${location.origin}?channel=1513246716`, // 分享链接
				imgUrl:
					wxShareConfigObj.imgUrl ||
					'https://zxcs.tengzhihh.com/forecastyiqiwenbundle/images/logo.png', // 分享图标
				type: wxShareConfigObj.type || '', // 分享类型,music、video或link，不填默认为link
				dataUrl: wxShareConfigObj.dataUrl || '', // 如果type是music或video，则要提供数据链接，默认为空
				success:
					wxShareConfigObj.success ||
					function () {
						that.shareData(wxShareConfigObj.title);
						// 分享成功后发送请求统计分享数量
						Vue.http
							.post(apiPath.shareStatic, {
								url:
									wxShareConfigObj.link ||
									`${location.origin}?channel=1513246716`,
								page_url: location.href
							})
							.then((res) => {})
							.catch((e) => {});
					},
				cancel: wxShareConfigObj.cancel || function () {}
			});
		});
	},
	/**
         *  调起客户端支付
         *  @params {object | payobj}  支付时所需要的参数传递
         *  {
         *      data : { //微信配置参数
         *      	 order_id: orderId, // 订单号
                     pay_point: config.PAY_POINT, // 付费点
                     pay_confirm_url: '',
                     server_id: config.SERVER_ID  // 服务id
         *      }
         *      successCb 微信支付成功后的回调
         *      failCb 微信支付失败后的回调
         *  }
         *  @return undefinded
         *      commonFn.wxPay({
         *                   wxPayConf:that.wxConfig.jsApiParameters,
         *                  successCb:that.wxPaySuc.bind(that,that.wxConfig.out_trade_no),
         *                 failCb:that.wxPayFail.bind(that),
         *                cancelCb:that.layer.bind(that,'支付失败，请重试')
         *     });
         *
         * */
	wxPay: function (payObj) {
		// 调起客户端支付
		window.mmc.client.mmcYiQiWenPay(payObj.data);
	},
	// 节流阀函数
	throttle: function (fn, delay) {
		var wait = false;
		return function () {
			var that = this,
				args = arguments;
			if (!wait) {
				wait = true;
				setTimeout(function () {
					fn.apply(that, args);
					wait = false;
				}, delay);
			}
		};
	},
	/**
	 * 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 idle，action 才会执行
	 * @param idle   {number}    空闲时间，单位毫秒
	 * @param action {function}  请求关联函数，实际应用需要调用的函数
	 * @return {function}    返回客户调用函数
	 */
	debounce: function (fn, idle) {
		var last;
		return function () {
			var that = this,
				args = arguments;
			clearTimeout(last);
			last = setTimeout(function () {
				fn.apply(that, args);
			}, idle);
		};
	},
	dateYearFormat: function (time) {
		var unixTimestamp = new Date(time * 1000);
		var y = unixTimestamp.getFullYear();
		var m = addZero(unixTimestamp.getMonth() + 1);
		var d = addZero(unixTimestamp.getDate());
		var commonTime;
		commonTime = y + '-' + m + '-' + d;
		return commonTime;
	},
	/**
	 * 时间格式转换
	 */
	dateFormat: function (time) {
		if (!time) {
			return '-';
		}
		// var unixTimestamp = new Date( time*1000 ) ;
		// var commonTime;
		// commonTime = unixTimestamp.toLocaleString();
		// return commonTime;
		var unixTimestamp = new Date(time * 1000);
		var y = unixTimestamp.getFullYear();
		var m = addZero(unixTimestamp.getMonth() + 1);
		var d = addZero(unixTimestamp.getDate());
		var h = addZero(unixTimestamp.getHours());
		var min = addZero(unixTimestamp.getMinutes());
		var sec = addZero(unixTimestamp.getSeconds());
		var commonTime;
		commonTime = y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + sec;
		return commonTime;
	},
	// 格式为 MM-dd HH:mm
	timeFormat: function (time) {
		if (!time) {
			return '-';
		}

		let unixTimestamp = new Date(time * 1000);
		let m = addZero(unixTimestamp.getMonth() + 1);
		let d = addZero(unixTimestamp.getDate());
		let h = addZero(unixTimestamp.getHours());
		let min = addZero(unixTimestamp.getMinutes());
		let commonTime;
		commonTime = m + '-' + d + ' ' + h + ':' + min;
		return commonTime;
	},
	dateFormatChina: function (time) {
		var unixTimestamp = new Date(time * 1000);
		var m = unixTimestamp.getMonth() + 1;
		var d = unixTimestamp.getDate();
		var h = addZero(unixTimestamp.getHours());
		var min = addZero(unixTimestamp.getMinutes());
		var commonTime;
		commonTime = m + '月' + d + '日 ' + h + ':' + min;
		return commonTime;
	},
	// 获得渠道标示，用于分享链接
	getChannelStr: function () {
		let url = location.href;
		let channel = '1513246716';
		let isFlag = url.indexOf('?');
		if (!channel) {
			return '';
		}
		if (isFlag !== -1) {
			return `&channel=${channel}`;
		} else {
			return `?channel=${channel}`;
		}
	},
	formateScore(value) {
		if (!value) {
			return '4.6';
		}
		return value >= 5 ? '5.0' : value + '';
	},
	formateMoney(value) {
		if (!value) {
			return 0;
		}
		let rValue = (+value).toFixed(2);
		var prizeStr = (rValue >= 1 ? parseFloat(rValue + '') : rValue) + '';
		return prizeStr.replace(/^(\d+)\.0+$/, '$1');
	},
	isIphone: function () {
		let ua = navigator.userAgent,
			Agents = ['iPhone', 'iPad', 'iPod'];
		return Agents.some(function (v) {
			return new RegExp(v, 'i').test(ua);
		});
	},
	// 睡几秒
	sleep(seconds) {
		return new Promise(function (resolve, reject) {
			setTimeout(resolve, seconds);
		});
	},

	// 根据支付链接支付
	goPayUrl(link = '', isAppBrower = false) {
		if (link) {
			if (isAppBrower && !commonFn.isH5() && !commonFn.parseUA().ios) {
				window.mmc.client.goto(
					{
						params: {
							action: 103,
							actioncontent: {
								global_type: link,
								func_type: '',
								data: {}
							},
							closeWindow: false
						}
					},
					() => {}
				);
			} else {
				location.href = link;
			}
		} else {
			// 没有支付链接
			Toast('支付链接不存在');
		}
	},

	// 已选择支付方式，下单之后立即调支付，公共处理
	commonPayHandle(res = null, payType = 'wechat') {
		if (!res) {
			return;
		}
		if (payType === 'alipay') {
			commonFn.goPayUrl(res.alipay_pay_url);
		} else if (commonFn.parseUA().weixin) {
			commonFn.goPayUrl(res.wechat_pay_url);
		} else if (payType === 'wechat') {
			// 微信外微信支付
			commonFn.goPayUrl(res.pay_url);
		} else if (payType === 'ecpay') {
			commonFn.goPayUrl(res.paypal_visitor);
		} else if (['linepay', 'paypal', 'newebpay'].includes(payType)) {
			commonFn.goPayUrl(res[payType], payType == 'linepay' && !commonFn.isH5());
		} else {
			commonFn.goPayUrl(res[payType]);
		}
	},

	// 百度小程序支付
	swanPay(order_id, return_url) {
		return new Promise(function (resolve, reject) {
			if (commonFn.isSwan()) {
				swan.webView.navigateTo({
					url: `/pages/pay/commonPay?order_id=${order_id}&return_url=${encodeURIComponent(
						return_url
					)}`
				});
				reject();
			} else {
				resolve();
			}
		});
	},
	// 大额支付判断
	largePay(order) {
		return new Promise(function (resolve, reject) {
			let {is_large_pay = false, large_url} = order;
			if (is_large_pay) {
				location.href = large_url;
				reject();
			} else {
				resolve();
			}
		});
	},
	// 显示页脚
	showFooter() {
		let $footerEle = document.querySelector('.footerbar');
		if ($footerEle) {
			document.querySelector('.footerbar').style.display = 'block';
		}
	},
	// 隐藏页脚
	hideFooter() {
		let $footerEle = document.querySelector('.footerbar');
		if ($footerEle) {
			document.querySelector('.footerbar').style.display = 'none';
		}
	},
	//大数据埋点公共方法
	submitData(moduleName, name, url) {
		var log_sign = md5('3&*yqw@#12F00');
		var channel = localStorage.getItem('channel') || '';
		var userClick = {
			module_name: moduleName,
			operation: '5',
			attr: {
				page_title: name /* url为下一页面的title */,
				page_url: url /* url为下一页面的url   */
			}
		};
		var data = {
			app_id: 'F00',
			log_type: '3',
			channel: channel,
			AB_tag: 'A/B',
			log_id: '',
			log_sign: log_sign,
			extra_data: JSON.stringify(userClick)
		};
		// Vue.http.post(apiPath.logInfo,data)
		// 	.then( res => {} )
		// 	.catch( e => {} );
	},
	/* 大数据调整 */
	bigOtherData(moduleName, attr) {
		var log_sign = md5('3&*yqw@#12F00');
		var channel = localStorage.getItem('channel') || '';
		var userClick = {
			module_name: moduleName,
			operation: 'F-5',
			attr: attr
		};
		var data = {
			app_id: 'F00',
			log_type: '3',
			channel: channel,
			log_id: '',
			log_sign: log_sign,
			extra_data: JSON.stringify(userClick)
		};
		// Vue.http.post(apiPath.logInfo, data)
		// 	.then(res => {
		// 	})
		// 	.catch(e => {
		// 	});
	},
	/* pc和移动端判断 */
	isMobileWeb() {
		let u = navigator.userAgent;
		return !!u.match(/AppleWebKit.*Mobile.*/); //是否为移动终端
	},
	/* 判断浏览器类型 */
	parseUA() {
		var u = navigator.userAgent;
		var u2 = navigator.userAgent.toLowerCase();
		return {
			//移动终端浏览器版本信息
			trident: u.indexOf('Trident') > -1, //IE内核
			presto: u.indexOf('Presto') > -1, //opera内核
			webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
			gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
			mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
			ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
			android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
			iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
			iPad: u.indexOf('iPad') > -1, //是否iPad
			webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
			iosv: u.substr(u.indexOf('iPhone OS') + 9, 3),
			weixin: u2.match(/MicroMessenger/i) == 'micromessenger',
			wxMiniprogram:
				(u.match(/MicroMessenger/i) && u.match(/miniprogram/i)) ||
				window.__wxjs_environment === 'miniprogram', //微信小程序环境
			ali: u.indexOf('AliApp') > -1,
			weibo: u2.match(/WeiBo/i) == 'weibo', //是否为微博客户端
			huawei:
				u2.indexOf('huawei') > -1 || u2.includes('openharmony') || u2.includes('harmonyos'),
			oppo:
				u2.includes('oppo') ||
				u2.includes('pcam10') ||
				u2.includes('pch') ||
				u2.includes('pbam00') ||
				u2.includes('pbec00') ||
				u2.includes('pbem00') ||
				u2.includes('heytapbrowser') ||
				u2.includes('padt00') ||
				u2.includes('pcdm10')
		};
	},
	appUA() {
		return [
			'ljruyuan',
			'yqw',
			'ljms',
			'ljbz',
			'fslp',
			'xingzuocheng',
			'bazipaipan',
			'zwds',
			'ksx',
			'qmjm',
			'ljds',
			'ydk',
			'zhiyuanpeidui',
			'laohuangli',
			'traditionaltools' //平台id是49 //应用名：顺兽紫微 //应用平台：iOS
		];
	},
	/* 判断是否是在公司已经内嵌易起问的app */
	isH5() {
		/* 目前四个app内嵌，灵机如愿，易起问，灵机妙算,灵机八字,风水楼盘 */
		let app = this.appUA();
		if (window.mmc.client.isAPP()) {
			if (this.isZwmp()) {
				return false;
			}
			if (
				app.some((val) => {
					return window.mmc.client.is(val);
				})
			) {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}

		/* 打开全部为h5状态 */
		// return true;
	},
	// 是否是紫薇命盘并且版本号大于1.2.1
	isZwmp() {
		const version = window.mmc.client.getAppVersionNum();
		const isApp = window.mmc.client.is('app_ios_1471953507');
		const isIos = window.mmc.client.isIOS();
		return isApp && isIos && version > 121;
	},
	// 判断是否是风水楼盘APP且版本大于3.7.8
	isFslp() {
		let version = window.mmc.client.getAppVersionNum();
		let isfslp = window.mmc.client.is('fslp');
		if (isfslp && version < 378) {
			return true;
		} else {
			return false;
		}
	},
	// 判断是否在风水罗盘APP
	isFslpApp() {
		return window.mmc.client.is('fslp');
	},
	// 判断是否是iOS星座城APP
	isXingZuoCheng() {
		return window.mmc.client.is('xingzuocheng') && window.mmc.client.isIOS();
	},
	// 判断是否是知缘配对APP
	isZhiYuanPeiDui() {
		return window.mmc.client.is('zhiyuanpeidui');
	},
	// 判断是否是易起问APP
	// 添加iOS易大咖，iOS易大咖修改为用户端
	isLjds() {
		const isYdkIos = window.mmc.client.is('ydk') && window.mmc.client.isIOS();
		return window.mmc.client.is('ljds') || isYdkIos;
	},
	isYdk: function () {
		if (window.mmc.client.isAPP()) {
			return window.mmc.client.is('ydk');
		} else {
			const platform = localStorage.getItem('platform') || '';
			if (ydkPlatform.includes(platform)) {
				return true;
			}
		}
		return false;
	},
	isLaoHuangLi() {
		return window.mmc.client.is('laohuangli');
	},
	isIosLjms() {
		return window.mmc.client.is('ljms') && window.mmc.client.isIOS();
	},
	isIosLjbz() {
		return window.mmc.client.is('ljbz') && window.mmc.client.isIOS();
	},
	isIosBazipaipan() {
		return window.mmc.client.is('bazipaipan') && window.mmc.client.isIOS();
	},
	// 灵机APP内嵌，不使用APP的支付，调H5微信、支付宝支付
	isAppUseH5Pay() {
		if (window.mmc.client.isAPP()) {
			// iOS，安卓都走H5支付的ua
			const appUa = [
				'fslp',
				'xingzuocheng',
				'ljds',
				'zhiyuanpeidui',
				'laohuangli',
				'ydk',
				'app_ios_1471953507',
				'traditionaltools'
			];
			return (
				this.isIosLjms() ||
				this.isIosLjbz() ||
				this.isIosBazipaipan() ||
				appUa.some((val) => window.mmc.client.is(val))
			);
		} else {
			return true;
		}
	},
	// 是否百度小程序
	isSwan() {
		let smartprogram = false;
		// console.log(swan, 'swan');
		window.swan &&
			swan.webView.getEnv((res) => {
				smartprogram = res.smartprogram;
				console.log('百度小程序环境', res);
			});
		console.log('百度小程序环境', smartprogram);
		return smartprogram;
	},
	/**
	 * 关联用户userid到大数据
	 * @param {用户userid} userid
	 */
	// linkUseridToSense(userid) {
	// 	try {
	// 		let LHMOUNT;
	// 		let loginUserLinkTimer = setInterval(() => {
	// 			LHMOUNT = commonFn.getCookieItem('LHMOUNT') || '';
	// 			if (window.h5_sense && window.h5_sense._status === 'fulfill') {
	// 				if (LHMOUNT !== userid) {
	// 					h5_sense.link(userid);
	// 					commonFn.setCookieItem('LHMOUNT', userid, Infinity, '/');
	// 				}
	// 				clearInterval(loginUserLinkTimer);
	// 			}
	// 		}, 1000);
	// 	} catch (error) {}
	// },
	// 获取某个字段的cookie
	getCookieItem(sKey) {
		return (
			decodeURIComponent(
				document.cookie.replace(
					new RegExp(
						'(?:(?:^|.*;)\\s*' +
							encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') +
							'\\s*\\=\\s*([^;]*).*$)|^.*$'
					),
					'$1'
				)
			) || null
		);
	},
	// 设置某个字段的cookie
	setCookieItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
		if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
			return false;
		}
		var sExpires = '';
		if (vEnd) {
			switch (vEnd.constructor) {
				case Number:
					sExpires =
						vEnd === Infinity
							? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
							: '; max-age=' + vEnd;
					break;
				case String:
					sExpires = '; expires=' + vEnd;
					break;
				case Date:
					sExpires = '; expires=' + vEnd.toUTCString();
					break;
			}
		}
		document.cookie =
			encodeURIComponent(sKey) +
			'=' +
			encodeURIComponent(sValue) +
			sExpires +
			(sDomain ? '; domain=' + sDomain : '') +
			(sPath ? '; path=' + sPath : '') +
			(bSecure ? '; secure' : '');
		return true;
	},
	// 删除某个字段的cookie
	removeCookieItem(sKey, sPath, sDomain) {
		if (!sKey || !this.hasItem(sKey)) {
			return false;
		}
		document.cookie =
			encodeURIComponent(sKey) +
			'=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
			(sDomain ? '; domain=' + sDomain : '') +
			(sPath ? '; path=' + sPath : '');
		return true;
	},
	// 包含某个字段的cookie
	hasItem: function (sKey) {
		return new RegExp(
			'(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\='
		).test(document.cookie);
	},
	/**
	 * @name: 正式环境添加点击事件埋点
	 * @param {
	 *  category：要监控的目标的类型名称，通常是同一组目标的名字，比如"视频"、"音乐"、"软件"、"游戏"等等。该项必选。
	 *  action：用户跟目标交互的行为，如"播放"、"暂停"、"下载"等等。该项必选。
	 *  opt_label：事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
	 *  opt_value：事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选。
	 * }
	 * @return:
	 */
	addTrackEvent: function (category = 'category', action = '', opt_label = '', opt_valu = '') {
		try {
			if (!commonFn.isSandbox()) {
				_hmt && _hmt.push(['_trackEvent', category, action, opt_label, opt_valu]);
			}
		} catch (error) {
			console.log(error);
		}
	},
	changeURLArg(url, arg, arg_val) {
		var pattern = arg + '=([^&]*)';
		var replaceText = arg + '=' + arg_val;
		if (url.match(pattern)) {
			var tmp = '/(' + arg + '=)([^&]*)/gi';
			tmp = url.replace(eval(tmp), replaceText);
			return tmp;
		} else {
			if (url.match('[?]')) {
				return url + '&' + replaceText;
			} else {
				return url + '?' + replaceText;
			}
		}
	},
	isSandbox() {
		let host = location.host;
		return (
			/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(host) ||
			/localhost/i.test(host) ||
			/sandbox/i.test(host)
		);
	},
	isSafari() {
		return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
	},
	// 判断是否百度投放渠道
	isBdChannel(channel = '') {
		return channel.indexOf('tftz_itjo') > -1 || channel.indexOf('tftz_m0xe') > -1;
	},
	// 投放渠道下载APP渠道匹配
	tfDlChannel(channel = '') {
		const actions = [
			// [/tftz_03fi_00008|tftz_03fi_00007|tftz_03fi_00006|tftz_03fi_00005|tftz_03fi_00004|tftz_03fi_00003|tftz_03fi_00002/, 'tzzc_xcx28'],
			[/tftz_03fi/, 'lingji_baidutl'],
			[/tftz_4sxg/, 'tzzc_xcx'],
			[/yqw_hiol/, 'lingji_xz_online'],
			[/tftz_520s/, 'lingji_bazihunyin'],
			[/tftz_obj6/, 'lingji_course'],
			[/tftz_tyli/, 'lingji_kuaishou'],
			[/ggtf-qg/, 'lingji_xiaoshuo'],
			[/tftz_a9wo|ggtf-tuia|tftz_njrz|tftz_htsn/, 'lingji_quzhuanxiang'],
			[/tftz_plvk|tftz_cjsc|tftz_ckfy|tftz_vwkn/, 'lingji_qinggan']
		];

		let action = actions.find((key) => key[0].test(channel)) || [];

		return action.length ? action[1] : channel;
	},
	isHuleChannel(
		channel = commonFn.getParams()['channel'] || localStorage.getItem('channel') || ''
	) {
		const huleChannel = ['tftz_4sxg', 'tftz_520s', 'tftz_03fi'];
		return huleChannel.find((i) => channel.indexOf(i) > -1);
	},
	dlBtnWord(channel = commonFn.getParams()['channel'] || localStorage.getItem('channel') || '') {
		// 知屿咨询添加企业微信渠道
		const addChannel = [
			'tftz_03fi_00008',
			'tftz_03fi_00007',
			'tftz_03fi_00006',
			'tftz_03fi_00005',
			'tftz_03fi_00004',
			'tftz_03fi_00003',
			'tftz_03fi_00002'
		];
		if (addChannel.includes(channel)) {
			return '添加老师，一对一解答';
		} else if (commonFn.isHuleChannel()) {
			return '点击下载并查看解析';
		} else {
			return '打开APP，收听老师解答';
		}
	},

	// 根据订单号获取支付链接支付
	async payByOrderId(orderId = '', payType = 'wechat') {
		if (!orderId) {
			return;
		}
		let res = await myAjax.get('comm/pay/url', {
			order_id: orderId
		});
		commonFn.commonPayHandle(res, payType);
	},

	// 从接口获取配置中心数据
	async getConfigTemp() {
		const channel = commonFn.getParams()['channel'] || localStorage.getItem('channel') || '';
		let {fields = null} = await myAjax.get(
			'https://relayfe.caij100.com/api/acttemp/pj/yqw_temp',
			{
				channel,
				env: commonFn.isSandbox() ? 1 : 0 // 1为测试服，其他为正式服
			}
		);

		return fields;
	},
	async getConfigTempGroup() {
		const channel = commonFn.getParams()['channel'] || localStorage.getItem('channel') || '';
		let res = await myAjax.get('https://relayfe.caij100.com/api/channel/group', {
			channel
		});

		return res;
	},
	// 从vuex/接口获取配置中心数据
	async getConfig() {
		let configTemp = store.state.configTemp;

		if (configTemp) {
			// vuex获取到配置中心数据
			// console.log('获取到vuex config:', configTemp);
			return configTemp;
		} else {
			// 没获取到配置中心数据，重新获取一下并设置到vuex
			// console.log('没获取到vuex config1:', configTemp);
			console.log('3365');
			let fields = await commonFn.getConfigTemp();
			let group = await commonFn.getConfigTempGroup();
			// console.log('没获取到vuex config2:', configTemp);
			if (fields) {
				store.commit('setConfigTemp', fields);
			}

			return fields;
		}
	},
	// 祈福灯弹窗
	showCommonQifuPop(openCb) {
		const pop = getCommonQifuPopInstance();
		pop.$off('open');
		pop.$on('open', () => {
			openCb && openCb();
		});
		pop.show();

		return pop;
	},
	// 跳转客户端
	goAppModule(global_type, func_type, data = {}, callBack = null, config = {}) {
		let {closeWindow, needRefresh, needCallback} = Object.assign(appConfig, config);

		window.mmc.client.goto(
			{
				params: {
					action: 110,
					actioncontent: {
						global_type,
						func_type,
						data
					},
					closeWindow,
					needRefresh,
					needCallback
				}
			},
			() => {
				console.log(global_type);
				callBack && callBack();
			}
		);
	},
	pageReturn() {
		if (commonFn.isLjds()) {
			window.mmc.client.goto(
				{
					params: {
						action: 110,
						actioncontent: {
							global_type: '',
							func_type: '',
							data: {}
						},
						closeWindow: true
					}
				},
				() => {}
			);
		} else {
			window.history.go(-1);
		}
	},
	/**
	 * 删除URL中的指定参数
	 * @param {*} url
	 * @param {*} name
	 */
	delUrlParams: function (url, name) {
		let urlArr = url.split('?');
		if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
			let query = urlArr[1];
			let obj = {};
			let arr = query.split('&');
			for (let i = 0; i < arr.length; i++) {
				arr[i] = arr[i].split('=');
				obj[arr[i][0]] = arr[i][1];
			}
			delete obj[name];
			let urlte =
				urlArr[0] +
				'?' +
				JSON.stringify(obj)
					.replace(/[\"\{\}]/g, '')
					.replace(/\:/g, '=')
					.replace(/\,/g, '&');
			return urlte;
		} else {
			return url;
		}
	},
	getChannel() {
		return commonFn.getParams()['channel'] || localStorage.getItem('channel') || '';
	},
	getConcatUrl() {
		return `https://kf.tingzhi66.com/?scene=10210000&app_id=S49&channel=${commonFn.getChannel()}&origin=知屿H5&u_id=`;
	},
	loadScript(src) {
		const script = document.createElement('script');
		script.async = true;
		script.src = src;

		document.head.append(script);

		return new Promise((resolve, reject) => {
			script.onload = resolve;
			script.onerror = reject;
		});
	},
	jumpLink(url) {
		const origin = this.isSandbox() ? 'https://sandbox-m.yiqiwen.cn' : 'https://m.yiqiwen.cn';
		location.href = `${origin}${url}`;
	},
	async getZxSetting(name, isJson = false) {
		try {
			const data = {
				os: 3,
				name,
				platform: '0',
				isOnlyData: 1
			};
			const res = await myAjax.get('/v1/zx/setting', data);
			if (!res || !res[name]) {
				throw new Error(`${name}没有获取到在参数据`);
			}

			if (isJson) return JSON.parse(res[name]);
			return res[name];
		} catch (e) {
			console.error(e);
		}

		await sleep(1000);
		return getZxSetting(name, isJson);
	}
};

(function () {
	// 保存链接中的渠道号到本地
	let channel = commonFn.getParams()['channel'];
	if (channel) {
		try {
			localStorage.setItem('channel', channel);
		} catch (e) {}
	}

	// 去掉微信强跳
	// if( commonFn.parseUA().weixin ){
	// 	location.href = "https://m.yiqiwen.cn/"
	// }
})();

export {commonFn};



// WEBPACK FOOTER //
// ./src/common/js/common.js